import simpleSoilAttribute from './simpleSoilAttribute';

export const DEPTH_TO_BEDROCK = simpleSoilAttribute({
  key: 'Depth to Bedrock',
  ratingCol: {
    displayString: 'Depth (cm)',
    accessor: 'mapUnitRatingString',
  },
  ruleId: '2851',
  shortFormData: { TiebreakRule: '-1' },
  units: 'cm',
});
